"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getLocaleFromLanguage = (language) => {
    if (/^[a-z]{2}-[a-z]{2}$/i.test(language)) {
        return language;
    }
    switch (language) {
        case "NORWEGIAN":
            return "nb-NO";
        case "ENGLISH":
            return "en-US";
        default:
            // tslint:disable-next-line
            console.warn(`No available local translation for language ${language}. Returning 'en-US'`);
            return "en-US";
    }
};
exports.default = getLocaleFromLanguage;
